import React, { useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from 'react-router';
// import { Alert } from "reactstrap";
import { publicRequest } from '../auth/requestMethods';
import { toast } from 'react-toastify';

const Signin = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    // error && setError("");
    setLoading(true);

    if (!email) {
      // return setError("Field cannot be empty");
      toast.error('Field cannot be empty');
    }
    publicRequest()
      .post('/users/forgot-password', { email })
      .then((res) => {
        toast.success(`Reset Link sent to ${email}`);
        setLoading(false);
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="container-fluid p-0">
          {/* <!-- login page start--> */}
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      <div className="text-center">
                        <img src={`${process.env.PUBLIC_URL}/pf-logo.svg`} width="300" alt="" />
                      </div>
                    </div>
                    <div className="card mt-4">
                      <div className="card-body">
                        <div className="text-center">
                          <h4>Forgot Password</h4>
                          <h6>{'Enter your Email'} </h6>
                        </div>
                        <form className="theme-form" onSubmit={onSubmit}>
                          <div className="form-group">
                            <label className="col-form-label pt-0">Email</label>
                            <input
                              className="form-control"
                              type="email"
                              name="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              placeholder="Email address"
                            />
                          </div>
                          <a className="btn-link text-capitalize" href={`${process.env.PUBLIC_URL}/`}>
                            Go to Login
                          </a>
                          <div className="form-group mt-3 mb-0 col-12">
                            {/* <Alert
                              isOpen={error === '0'}
                              color="success dark text-center"
                            >
                              Reset Link sent to {email}
                            </Alert> */}
                            {/* <Alert isOpen={error && error !== "0"} color="danger dark text-center">
                              {error}
                            </Alert> */}
                            {loading && (
                              <div className="loader d-flex justify-content-center mb-1">
                                <div className="line bg-primary"></div>
                                <div className="line bg-primary"></div>
                                <div className="line bg-primary"></div>
                                <div className="line bg-primary"></div>
                              </div>
                            )}
                          </div>
                          <div className="form-group form-row mt-3 mb-0">
                            <button disabled={loading} className="btn btn-primary btn-block col-12" type="submit">
                              Send
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- login page end--> */}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Signin);
